import { tzOffset, tzScan } from '@date-fns/tz';
import { endOfYear, format, startOfYear } from 'date-fns';
import type { IanaId } from '@common/types/brandedTypes';

const dstLessIanaId = (
  ianaId: IanaId,
) => {
  const now = Date.now();
  const changes = tzScan(ianaId, {
    start: startOfYear(now),
    end: endOfYear(now),
  });

  const offset = changes.length > 0
    ? changes.toSorted((a, b) => a.offset - b.offset)[0].offset
    : tzOffset(ianaId, new Date(now));
  const temp = new Date(2000, 0, 1, Math.abs(offset) / 60, Math.abs(offset) % 60, 0);
  return `${offset >= 0 ? '+' : '-'}${format(temp, 'HH:mm')}` as IanaId;
};

export default dstLessIanaId;
